import { http } from "./http.js";

async function getClientDraft(id) {
  const response = await http.get(`clients/drafts/${id}`);
  return response;
}

async function createClientDraft(id, entity) {
  const response = await http.post(`clients/drafts/${id}`, entity);
  return response;
}

async function deleteClientDraft(id) {
  const response = await http.delete(`clients/drafts/${id}`);
  return response;
}

async function getAllClientDrafts() {
  const response = await http.get("clients/drafts");
  return response.data;
}

async function importClientsFile(fileInfo) {
  const response = await http.post("clients/import", fileInfo);
  return response;
}

async function getAllFactoryDrafts() {
  const response = await http.get("factories/drafts");
  return response.data;
}

async function getFactoryDraft(id) {
  const response = await http.get(`factories/drafts/${id}`);
  return response.data;
}

async function createFactoryDraft(id, entity) {
  const response = await http.post(`factories/drafts/${id}`, entity);
  return response;
}

async function deleteFactoryDraft(id) {
  const response = await http.delete(`factories/drafts/${id}`);
  return response;
}

async function importFactoriesFile(fileInfo) {
  const response = await http.post("factories/import", fileInfo);
  return response;
}

async function getAllImportDrafts() {
  const response = await http.get("goods/import/drafts");
  return response.data;
}

async function importDrafts(drafts) {
  const response = await http.post("goods/import/drafts", drafts);
  return response;
}

async function deleteDraft(id) {
  const response = await http.delete(`goods/import/drafts/${id}`);
  return response;
}

async function importGoodsFile(fileInfo) {
  const response = await http.post("goods/import", fileInfo);
  return response.data;
}

async function importLocations(fileInfo) {
  const response = await http.post("locations/import", fileInfo);
  return response;
}

async function updateGoodsItem(id, item) {
  const response = await http.put(`goods/import/drafts/${id}`, item);
  return response;
}

async function importShippingReleaseApprovement(fileInfo) {
  const response = await http.post("shipping-release-approvement/import", fileInfo);
  return response;
}

export {
  getClientDraft,
  createClientDraft,
  deleteClientDraft,
  getAllClientDrafts,
  importClientsFile,
  getAllFactoryDrafts,
  getFactoryDraft,
  createFactoryDraft,
  deleteFactoryDraft,
  importFactoriesFile,
  getAllImportDrafts,
  importDrafts,
  deleteDraft,
  importGoodsFile,
  importLocations,
  updateGoodsItem,
  importShippingReleaseApprovement,
};
